import { render, staticRenderFns } from "./AppBottomTab.vue?vue&type=template&id=09007a97&scoped=true&"
import script from "./AppBottomTab.vue?vue&type=script&lang=js&"
export * from "./AppBottomTab.vue?vue&type=script&lang=js&"
import style0 from "./AppBottomTab.vue?vue&type=style&index=0&id=09007a97&lang=scss&scoped=true&"
import style1 from "./AppBottomTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09007a97",
  null
  
)

export default component.exports